const BYTES_IN_KILOBYTE = 1024
const KILOBYTES_TO_MEGABYTE = 1024

export const formatMegabytesToBytes = (megabytes: number): number =>
  megabytes * (BYTES_IN_KILOBYTE * KILOBYTES_TO_MEGABYTE)
